import { Divider } from "antd";

import { BaseDividerProps } from "./types";

import "./styles.css";

const BaseDivider = ({ children, className, ...props }: BaseDividerProps) => {
  return (
    <div className={`base-divider ${className}`}>
      <Divider {...props}>{children}</Divider>
    </div>
  );
};

export default BaseDivider;
